import { connectRefinementList } from 'react-instantsearch-dom'

import RefinementList from 'views/components/organisms/AlgoliaInstantSearch/Algolia/RefinementList'

const MultipleSelectionList = props => <RefinementList {...props} />

MultipleSelectionList.propTypes = {
  ...RefinementList.propTypes,
}

MultipleSelectionList.defaultProps = {
  ...RefinementList.defaultProps,
}

export default connectRefinementList(MultipleSelectionList)
